var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkoutBro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.91,317.7A194.65,194.65,0,0,0,222.47,326s10.22,15.65,0,36.1l42.8,20.45,17.89-54.31Zm-14.5,21.62L246,354.9a2.76,2.76,0,0,1-3.31,1.77l-13.51-3.51s3.2-5.43,1.92-16l17.46-1.54A2.77,2.77,0,0,1,251.41,339.32Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.9,262s17.87,2.43,28.47.91,9.39-10,7.57-14.23-8.78-2.73-16.66-1.51-9.69,3.93-16.35,5.45-12.11.9-11.51,4.84S299.9,262,299.9,262Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.59,120.1s-5.63,4.47-6.21,8.36.58,8.75-.78,11.47-4.47,3.69-3.5,5,4.08,2.33,4.08,2.33,1.94,7.19,3.89,10.5,4.08,7,7.19,7a7.83,7.83,0,0,0,5.25-2.33s8,6.22,10.1,8,15.55-20.66,15.55-20.66l-7-3.63a19.18,19.18,0,0,0,1.17-3.89,22.67,22.67,0,0,0-3.11-14.58C239.14,120.69,228.84,112.52,216.59,120.1Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.81,151.94s-9.22-5.79-18.63-2-17.35,29.11-17,38.51,8.5,24.77,18.26,27.12,11.75-.36,11.75-.36.55,5.79,4.88,9.22,6.15,3.8,6.15,3.8S263.89,240,278.18,248s35.62,9,45.38,5.42,14.83-17.54,15.19-30.92-8.5-20.07-12.66-24-17.9-8.86-17.9-8.86S295.35,174.36,284.32,165A74.42,74.42,0,0,0,262.81,151.94Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.63,193A120.47,120.47,0,0,0,287.79,168q-1.74-1.62-3.47-3.09a80.08,80.08,0,0,0-8.45-6.28l-2.76,3.75s-9.25-9.35-15.4-12.06c-.84-.37-4.91-1.44-5.77-1.67a18.34,18.34,0,0,0-7.76,1.26,11.22,11.22,0,0,0-3.47,2.39c1.28-.14,5-1.68,6.48-1.68,8.32,0,13.59,5.47,15.94,7.82s7.27,9,7.27,9a30.18,30.18,0,0,1-12.47,16.27c-10.13,6.69-21.34,10.12-25.86,10.12a30.85,30.85,0,0,0-4,.08c2.42,9,9.34,19.69,17.36,21.62,9.76,2.35,11.75-.36,11.75-.36S268.41,210,277.63,193Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-6--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.63,155.74s-8,1-13.33,9.66-17,44-17,44-18.33,1-25.67-.66-15-5.34-18.66-8.34-5-5.66-8.34-5.33-7.66,2-8,4a20.78,20.78,0,0,0-.33,3S159,211.4,162,211.4s2.66-2.33,4.66-3.66,2,1.72,7.33,2c0,0,18.37,10.31,28.67,15.61,9.65,5,20.67,6.67,24.67,3.67s21.33-29,27.67-52.33",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.56,145S399.23,99.3,345.51,92.53s-91.24,26.24-130.77,43.17c-20.71,8.87-44.35,5.43-66.33,9.72C78.13,159.14,51.65,245.1,80.93,294c25.34,42.32,69.94,64.33,137.86,69.41s115.56,11,176.39-30.47S451.94,205.11,423.56,145Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.56,145S399.23,99.3,345.51,92.53s-91.24,26.24-130.77,43.17c-20.71,8.87-44.35,5.43-66.33,9.72C78.13,159.14,51.65,245.1,80.93,294c25.34,42.32,69.94,64.33,137.86,69.41s115.56,11,176.39-30.47S451.94,205.11,423.56,145Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-11"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250.67,
    cy: 404.18,
    rx: 199.3,
    ry: 19.77,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 250.67,
    cy: 404.18,
    rx: 199.3,
    ry: 19.77,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.2,259.52c-4.81,4-8.22,8.79-12.33,13.91A135.62,135.62,0,0,0,283,286.61c-4.71,7.62,5.24,71.05,5.24,71.05l-9.47,3.56S258,301.49,256.17,288.06s13.43-38.1,20-44.27,29.76-10.17,38.1-.73c4.83,5.46.14,10.36-4.61,13.28A37.58,37.58,0,0,0,305.2,259.52Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,371c0-1.94-2.78-8.74-4.75-13.31-5.8,2.56-9.59,2.31-9.59,2.31a9.92,9.92,0,0,0-3,3.33c-1,2-8.33,5.34-12.33,6.67s-6.33,3.33-4,5,19,.67,25-.33S293,374,293,371Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.67,363.3c-1,2-8.33,5.34-12.33,6.67s-6.33,3.33-4,5,19,.67,25-.33S293,374,293,371c0-1.3-1.26-4.79-2.67-8.33L281,365l-2.34-5A9.92,9.92,0,0,0,275.67,363.3Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.3,268h11.06a5.41,5.41,0,0,1,5.39,5.85l-1.44,17.8L203,288.13Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.91,317.7A194.65,194.65,0,0,0,222.47,326s10.22,15.65,0,36.1l42.8,20.45,17.89-54.31Zm-14.5,21.62L246,354.9a2.76,2.76,0,0,1-3.31,1.77l-13.51-3.51s3.2-5.43,1.92-16l17.46-1.54A2.77,2.77,0,0,1,251.41,339.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-11)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.91,317.7A194.65,194.65,0,0,0,222.47,326s10.22,15.65,0,36.1l42.8,20.45,17.89-54.31Zm-14.5,21.62L246,354.9a2.76,2.76,0,0,1-3.31,1.77l-13.51-3.51s3.2-5.43,1.92-16l17.46-1.54A2.77,2.77,0,0,1,251.41,339.32Z",
    style: {
      stroke: "#263238",
      strokeMiterlimit: 10,
      opacity: 0.31
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M265.91,317.7A194.65,194.65,0,0,0,222.47,326s10.22,15.65,0,36.1l42.8,20.45,17.89-54.31Zm-14.5,21.62L246,354.9a2.76,2.76,0,0,1-3.31,1.77l-13.51-3.51s3.2-5.43,1.92-16l17.46-1.54A2.77,2.77,0,0,1,251.41,339.32Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.13,281.4s81.5,16,146.5,115h-16.5s-53-79.5-127.5-103.5Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.03,
    cy: 344.55,
    r: 40.25,
    transform: "translate(-198.05 395.87) rotate(-68.07)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.03,
    cy: 344.55,
    r: 31.15,
    transform: "translate(-53.18 35.92) rotate(-9.31)",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.52 294.65 300.54 294.16 307.31 260.99 313.29 261.48 306.52 294.65",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.41,
    y: 300.69,
    width: 6.34,
    height: 2.87,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.45,288.32l15.37,1.57-15.06,96.6s25.72,5.65,41.41,11v8.47s-31.68-9.41-64.62-11.92-77.15,4.71-77.15,4.71v-9.1s35.75-5.33,65.24-5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.29,
    y: 297.06,
    width: 3.47,
    height: 9.21,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.07,
    y: 322.18,
    width: 141.12,
    height: 10,
    transform: "matrix(0.08, -1, 1, 0.08, -145.51, 496.43)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.57,
    y: 242.11,
    width: 23.56,
    height: 6,
    transform: "translate(-57.56 427.76) rotate(-85.31)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.9,262s17.87,2.43,28.47.91,9.39-10,7.57-14.23-8.78-2.73-16.66-1.51-9.69,3.93-16.35,5.45-12.11.9-11.51,4.84S299.9,262,299.9,262Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-11)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.9,262s17.87,2.43,28.47.91,9.39-10,7.57-14.23-8.78-2.73-16.66-1.51-9.69,3.93-16.35,5.45-12.11.9-11.51,4.84S299.9,262,299.9,262Z",
    style: {
      stroke: "#263238",
      strokeMiterlimit: 10,
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M299.9,262s17.87,2.43,28.47.91,9.39-10,7.57-14.23-8.78-2.73-16.66-1.51-9.69,3.93-16.35,5.45-12.11.9-11.51,4.84S299.9,262,299.9,262Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.48,237.56c-10.36,0-27.24-.95-34.31-4.49-9.77-4.88-28.53-22-29.33-22.69a4,4,0,0,1,5.4-5.91c.18.17,18.73,17.06,27.51,21.45,7.58,3.79,33.53,3.85,37.24,3.5a4,4,0,0,1,2,7.73A51.29,51.29,0,0,1,225.48,237.56Zm6-8h0Zm0,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,347.6l-.27,19.16a2.76,2.76,0,0,0,2.75,2.8h0a2.75,2.75,0,0,0,2.73-3.14L282.47,347Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.69,366.82a3.45,3.45,0,1,0-3.45,3.45A3.45,3.45,0,0,0,285.69,366.82Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.12,
    y: 343.52,
    width: 18.82,
    height: 4.39,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.88 397.09 176.09 413.47 176.09 415.26 194.23 415.26 194.23 412.7 195.84 397.91 185.88 397.09",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.09,
    y1: 413.47,
    x2: 193.47,
    y2: 413.47,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.63 396.4 348.98 413.47 348.96 415.26 327.13 415.26 327.38 412.7 330.13 396.4 346.63 396.4",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.98,
    y1: 413.47,
    x2: 328.07,
    y2: 413.47,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.59,120.1s-5.63,4.47-6.21,8.36.58,8.75-.78,11.47-4.47,3.69-3.5,5,4.08,2.33,4.08,2.33,1.94,7.19,3.89,10.5,4.08,7,7.19,7a7.83,7.83,0,0,0,5.25-2.33s8,6.22,10.1,8,15.55-20.66,15.55-20.66l-7-3.63a19.18,19.18,0,0,0,1.17-3.89,22.67,22.67,0,0,0-3.11-14.58C239.14,120.69,228.84,112.52,216.59,120.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-11)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.16,146.15a19.18,19.18,0,0,0,1.17-3.89,22.67,22.67,0,0,0-3.11-14.58,23,23,0,0,0-9.2-8.76l-10.5,7.18s-3.08,2.31-1.8,5.14,6.95,9.51,8.75,14.39-.52,11.31-4.37,14.14c-2.28,1.67-5.27,3.34-6.65,4.59a4.06,4.06,0,0,0,1.81.44,7.83,7.83,0,0,0,5.25-2.33s6,4.65,9,7l2.47.51c4-3.19,14.23-20.24,14.23-20.24Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.16,146.15a19.18,19.18,0,0,0,1.17-3.89,22.67,22.67,0,0,0-3.11-14.58,23,23,0,0,0-9.2-8.76l-10.5,7.18s-3.08,2.31-1.8,5.14,6.95,9.51,8.75,14.39-.52,11.31-4.37,14.14c-2.28,1.67-5.27,3.34-6.65,4.59a4.06,4.06,0,0,0,1.81.44,7.83,7.83,0,0,0,5.25-2.33s6,4.65,9,7l2.47.51c4-3.19,14.23-20.24,14.23-20.24Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M216.59,120.1s-5.63,4.47-6.21,8.36.58,8.75-.78,11.47-4.47,3.69-3.5,5,4.08,2.33,4.08,2.33,1.94,7.19,3.89,10.5,4.08,7,7.19,7a7.83,7.83,0,0,0,5.25-2.33s8,6.22,10.1,8,15.55-20.66,15.55-20.66l-7-3.63a19.18,19.18,0,0,0,1.17-3.89,22.67,22.67,0,0,0-3.11-14.58C239.14,120.69,228.84,112.52,216.59,120.1Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.91,149.5s.44-2,2.2-1.54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.4,138.47c0,1-.39,1.85-.87,1.85s-.88-.83-.88-1.85.39-1.85.88-1.85S216.4,137.45,216.4,138.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.49,135.46s1.16-3.5,4.27-1.56",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.51,162.47s5.63-3.5,7-9.72",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.81,151.94s-9.22-5.79-18.63-2-17.35,29.11-17,38.51,8.5,24.77,18.26,27.12,11.75-.36,11.75-.36.55,5.79,4.88,9.22,6.15,3.8,6.15,3.8S263.89,240,278.18,248s35.62,9,45.38,5.42,14.83-17.54,15.19-30.92-8.5-20.07-12.66-24-17.9-8.86-17.9-8.86S295.35,174.36,284.32,165A74.42,74.42,0,0,0,262.81,151.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-11)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.33,199.07c1.06-2,1.46-5.43,1.28-9.37l-.42-.16S295.35,174.36,284.32,165a74.42,74.42,0,0,0-21.51-13,24.54,24.54,0,0,0-6.16-2.52c-2.83.5-3,1.8,1.06,5.15,7.33,6.06,9,24.66,6.92,28.57s-8.72-3.31-13.83.9-3.43,24.77,6.4,31.18a100.16,100.16,0,0,0,23.07,2.5C293.8,217.72,304,205.39,307.33,199.07Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.33,199.07c1.06-2,1.46-5.43,1.28-9.37l-.42-.16S295.35,174.36,284.32,165a74.42,74.42,0,0,0-21.51-13,24.54,24.54,0,0,0-6.16-2.52c-2.83.5-3,1.8,1.06,5.15,7.33,6.06,9,24.66,6.92,28.57s-8.72-3.31-13.83.9-3.43,24.77,6.4,31.18a100.16,100.16,0,0,0,23.07,2.5C293.8,217.72,304,205.39,307.33,199.07Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M262.81,151.94s-9.22-5.79-18.63-2-17.35,29.11-17,38.51,8.5,24.77,18.26,27.12,11.75-.36,11.75-.36.55,5.79,4.88,9.22,6.15,3.8,6.15,3.8S263.89,240,278.18,248s35.62,9,45.38,5.42,14.83-17.54,15.19-30.92-8.5-20.07-12.66-24-17.9-8.86-17.9-8.86S295.35,174.36,284.32,165A74.42,74.42,0,0,0,262.81,151.94Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.63,193A120.47,120.47,0,0,0,287.79,168q-1.74-1.62-3.47-3.09a80.08,80.08,0,0,0-8.45-6.28l-2.76,3.75s-9.25-9.35-15.4-12.06c-.84-.37-4.91-1.44-5.77-1.67a18.34,18.34,0,0,0-7.76,1.26,11.22,11.22,0,0,0-3.47,2.39c1.28-.14,5-1.68,6.48-1.68,8.32,0,13.59,5.47,15.94,7.82s7.27,9,7.27,9a30.18,30.18,0,0,1-12.47,16.27c-10.13,6.69-21.34,10.12-25.86,10.12a30.85,30.85,0,0,0-4,.08c2.42,9,9.34,19.69,17.36,21.62,9.76,2.35,11.75-.36,11.75-.36S268.41,210,277.63,193Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-5--inject-11)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.63,193c-9.22,17-20.43,22.24-20.43,22.24s-2,2.71-11.75.36a16.33,16.33,0,0,1-6.94-3.94c4.06.33,12.44.29,12-5.65-.36-4.69-3-11-4.85-15.74a75.54,75.54,0,0,0,9.52-4.77c5.11,1.27,11.05,2.61,15.77,2.47,0,0,5.83.55,9.61-.7C279.66,189.11,278.7,191,277.63,193Zm-14.5-34.5c.53.53,1.2,1.29,1.91,2.15,8.23,5.43,15.79,15.85,17.78,21.57a116.08,116.08,0,0,0,5-14.16q-1.74-1.62-3.47-3.09a80.08,80.08,0,0,0-8.45-6.28l-2.76,3.75s-9.25-9.35-15.4-12.06c-.84-.37-4.91-1.44-5.77-1.67a18.34,18.34,0,0,0-7.76,1.26,11.22,11.22,0,0,0-3.47,2.39c1.28-.14,5-1.68,6.48-1.68C255.51,150.66,260.78,156.13,263.13,158.48Z",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M277.63,193A120.47,120.47,0,0,0,287.79,168q-1.74-1.62-3.47-3.09a80.08,80.08,0,0,0-8.45-6.28l-2.76,3.75s-9.25-9.35-15.4-12.06c-.84-.37-4.91-1.44-5.77-1.67a18.34,18.34,0,0,0-7.76,1.26,11.22,11.22,0,0,0-3.47,2.39c1.28-.14,5-1.68,6.48-1.68,8.32,0,13.59,5.47,15.94,7.82s7.27,9,7.27,9a30.18,30.18,0,0,1-12.47,16.27c-10.13,6.69-21.34,10.12-25.86,10.12a30.85,30.85,0,0,0-4,.08c2.42,9,9.34,19.69,17.36,21.62,9.76,2.35,11.75-.36,11.75-.36S268.41,210,277.63,193Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.63,155.74s-8,1-13.33,9.66-17,44-17,44-18.33,1-25.67-.66-15-5.34-18.66-8.34-5-5.66-8.34-5.33-7.66,2-8,4a20.78,20.78,0,0,0-.33,3S159,211.4,162,211.4s2.66-2.33,4.66-3.66,2,1.72,7.33,2c0,0,18.37,10.31,28.67,15.61,9.65,5,20.67,6.67,24.67,3.67s21.33-29,27.67-52.33",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-6--inject-11)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.69,178.32c-3.61,1.51-10.52,18.35-16.24,29.77S218,227,206,222.53c-5.44-2-27.67-10.53-27.67-10.53l.4.45c6.15,3.42,16.9,9.34,23.91,13,9.65,5,20.67,6.67,24.67,3.67,3.17-2.38,14.7-19.19,22.5-37.67C250.36,187.59,251.65,177.09,248.69,178.32Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.69,178.32c-3.61,1.51-10.52,18.35-16.24,29.77S218,227,206,222.53c-5.44-2-27.67-10.53-27.67-10.53l.4.45c6.15,3.42,16.9,9.34,23.91,13,9.65,5,20.67,6.67,24.67,3.67,3.17-2.38,14.7-19.19,22.5-37.67C250.36,187.59,251.65,177.09,248.69,178.32Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M246.63,155.74s-8,1-13.33,9.66-17,44-17,44-18.33,1-25.67-.66-15-5.34-18.66-8.34-5-5.66-8.34-5.33-7.66,2-8,4a20.78,20.78,0,0,0-.33,3S159,211.4,162,211.4s2.66-2.33,4.66-3.66,2,1.72,7.33,2c0,0,18.37,10.31,28.67,15.61,9.65,5,20.67,6.67,24.67,3.67s21.33-29,27.67-52.33",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,203.41s.94-3.46,2.67-4.4a17.49,17.49,0,0,1,3.61-1.41",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.53,206.08a19,19,0,0,1,3.45-4.71,7.17,7.17,0,0,1,4.08-1.42",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.67,210.63s-1.1-3.3.47-4.71,5.65-2.51,5.65-2.51",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.09,198.4c-4.17-3.39-16.15-8.22-17.73-8.79-19.71,32.31-40.13,38.63-40.13,38.63S263.89,240,278.18,248s35.62,9,45.38,5.42,16.68-16.5,17-29.88S331.35,202.68,326.09,198.4Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.3,216.74s-22,6.33-41.33,16.66-39.67,36-37.34,40,50.67,56,50.67,56a10,10,0,0,0-3,3.34c-1,2-8.33,5.33-12.33,6.66s-6.34,3.34-4,5,19,.67,25-.33,8.66-.67,8.66-3.67S290,322.74,290,322.74L272,273.4s51.33-12.66,59.66-26.33,7.12-24.62,7.12-24.62",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 271.97,
    y1: 273.4,
    x2: 260.97,
    y2: 275.74,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.63,340.4c0-1.93-2.78-8.73-4.75-13.31-5.8,2.56-9.58,2.31-9.58,2.31a10,10,0,0,0-3,3.34c-1,2-8.33,5.33-12.33,6.66s-6.34,3.34-4,5,19,.67,25-.33S296.63,343.4,296.63,340.4Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.3,332.74c-1,2-8.33,5.33-12.33,6.66s-6.34,3.34-4,5,19,.67,25-.33,8.66-.67,8.66-3.67c0-1.3-1.25-4.79-2.67-8.33l-9.33,2.33-2.33-5A10,10,0,0,0,279.3,332.74Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.13,232.9s29-16.5,47-21",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.87,123.21s7.39-2.33,8.17-.77-3.11,7-1,7.77,6.42,3.11,6.61,5,2,4.28,3.31,3.31.19-4.09,3.69-4.09,4.27,5.45,2.53,7.78-4.67,3.89-3.5,4.08,7.58.58,12.05-1.17,6.23-13,5-20.22a18.13,18.13,0,0,0-15.34-15.17c-5.08-.44-12.24,2.94-12.24,2.94s-6.41-3.11-10.3,1.94a9.41,9.41,0,0,0-1,10.11Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.66,130.6a4.09,4.09,0,0,1,4.08-4.86c4.86-.39,9.72,3.89,9.92,8.16s-1.37,10.11-7.2,9.91-7-3.49-7-3.49Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkoutBro);
export default __webpack_public_path__ + "static/media/Workout-bro.a7e0fcbd82231a4f07b8ca72c5e47504.svg";
export { ForwardRef as ReactComponent };